import { useState } from 'react';
import { X, Search, ArrowUpDown, ChevronDown } from 'lucide-react';

// Predefined list for declaracion_1 (Casilla 1.1 - DECLARACIÓN)
export function getDeclaraciones1() {
  return [
    { 
      codigo: "CO", 
      nombre: "Declaración de expedición de mercancía comunitaria a otra parte del territorio comunitario." 
    },
    { 
      codigo: "EX", 
      nombre: "Declaración de exportación de mercancías comunitarias o no comunitarias desde la Península y Baleares o desde las Islas Canarias hacia el exterior del territorio aduanero de la Comunidad. Incluye también exportación desde Ceuta y Melilla con cualquier destino. También avituallamiento y equipamiento a buques y aeronaves." 
    },
  ];
}

export const Declaracion1Modal = ({
  declaraciones = [],
  isOpen,
  onClose,
  onSelect,
  selectedDeclaracion,
  title = 'Select Declaration 1',
  isSpanish = true,
}) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [sortBy, setSortBy] = useState('code-asc');
  const [isSortOpen, setIsSortOpen] = useState(false);

  const sortOptions = [
    { value: 'code-asc', label: isSpanish ? 'Código (A-Z)' : 'Code (A-Z)' },
    { value: 'code-desc', label: isSpanish ? 'Código (Z-A)' : 'Code (Z-A)' },
    { value: 'name-asc', label: isSpanish ? 'Nombre (A-Z)' : 'Name (A-Z)' },
    { value: 'name-desc', label: isSpanish ? 'Nombre (Z-A)' : 'Name (Z-A)' },
  ];

  const filteredDeclaraciones = declaraciones.filter((declaracion) =>
    declaracion.nombre.toLowerCase().includes(searchQuery.toLowerCase()) ||
    declaracion.codigo.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const sortedDeclaraciones = [...filteredDeclaraciones].sort((a, b) => {
    switch (sortBy) {
      case 'code-asc':
        return a.codigo.localeCompare(b.codigo);
      case 'code-desc':
        return b.codigo.localeCompare(a.codigo);
      case 'name-asc':
        return a.nombre.localeCompare(b.nombre);
      case 'name-desc':
        return b.nombre.localeCompare(a.nombre);
      default:
        return 0;
    }
  });

  const getSortLabel = () => {
    return sortOptions.find((option) => option.value === sortBy)?.label || (isSpanish ? 'Ordenar por' : 'Sort by');
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-2xl mx-4">
        <div className="flex justify-between items-center mb-4">
          <div>
            <h2 className="text-xl font-bold">{isSpanish ? 'DECLARACIÓN (Oblig.)' : 'DECLARATION (Obligatory)'}</h2>
            <p className="text-sm text-gray-600 mt-1">
              {isSpanish 
                ? "Se pondrá una de las claves siguientes, de acuerdo con el estatuto y destino de las mercancías:"
                : "One of the following keys will be entered, according to the status and destination of the goods:"}
            </p>
          </div>
          <button
            onClick={() => {
              setSearchQuery('');
              setIsSortOpen(false);
              onClose();
            }}
            className="p-1 hover:bg-gray-100 rounded-full"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        <div className="flex gap-2 mb-4">
          {/* Search Input */}
          <div className="relative flex items-center gap-2 border-container rounded-full px-3 py-1 flex-1 flex-row">
            <div className="flex-0 pointer-events-none">
              <Search className="h-5 w-5 text-gray-400" />
            </div>
            <input
              type="text"
              className="pr-4 py-2 !border-none no-border search-input"
              style={{ borderWidth: '0px !important', border: '0px !important' }}
              placeholder={isSpanish ? "Buscar declaración..." : "Search declaration..."}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>

          {/* Custom Sort Dropdown */}
          <div className="relative button-no-hover-effect text-sm">
            <button
              className="flex items-center gap-2 px-2 pr-0 py-2 rounded-full"
              onClick={() => setIsSortOpen(!isSortOpen)}
            >
              <ArrowUpDown className="w-4 h-4" />
              <span>{getSortLabel()}</span>
              <ChevronDown className={`w-4 h-4 transition-transform ${isSortOpen ? 'rotate-180' : ''}`} />
            </button>

            {isSortOpen && (
              <div className="overflow-hidden absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg border-container py-1 z-10">
                {sortOptions.map((option) => (
                  <button
                    key={option.value}
                    className={`w-full text-left px-4 py-2 text-sm hover:bg-gray-100 ${
                      sortBy === option.value ? 'text-primary' : 'text-gray-700'
                    }`}
                    onClick={() => {
                      setSortBy(option.value);
                      setIsSortOpen(false);
                    }}
                  >
                    {option.label}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="max-h-[60vh] min-h-[60vh] overflow-y-auto">
          {declaraciones.length > 0 ? (
            <div className="space-y-0">
              {sortedDeclaraciones.length > 0 ? (
                sortedDeclaraciones.map((declaracion) => (
                  <div
                    key={declaracion.codigo}
                    className={`p-3 px-0 hover:bg-gray-100 cursor-pointer border-bottom-gray ${
                      selectedDeclaracion &&
                      (selectedDeclaracion?.codigo === declaracion.codigo || selectedDeclaracion === declaracion.codigo || (typeof selectedDeclaracion === 'string' && selectedDeclaracion === declaracion.codigo))
                        ? 'bg-gray-100 font-bold'
                        : ''
                    }`}
                    onClick={() => {
                      onSelect(declaracion);
                      setSearchQuery('');
                      setIsSortOpen(false);
                      onClose();
                    }}
                  >
                    <div className="flex justify-between items-start gap-2">
                      <div className="flex-1">
                        <div className="flex items-center gap-2 mb-1">
                          <span className="font-bold text-lg">{declaracion.codigo}</span>
                        </div>
                        <p className="text-sm text-gray-700">{declaracion.nombre}</p>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-center py-4 text-gray-500">
                  {isSpanish 
                    ? `No se encontraron declaraciones que coincidan con "${searchQuery}"`
                    : `No declarations found matching "${searchQuery}"`}
                </div>
              )}
            </div>
          ) : (
            <div className="text-center py-4">
              <p className='opacity-75 mb-4'>{isSpanish ? 'No hay declaraciones disponibles' : 'No Declarations Available'}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

